import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Modal, Loading, SystemText } from 'e4shared';

import Logins from './components/logins';
import BlogPosts from 'components/general/blogPosts';
import Tasks from './components/tasks';
import KnowledgeBankQuestions from './components/knowledgeBankQuestions';
import KnowledgeBankAnswers from './components/knowledgeBankAnswers';
import Badges from 'components/user/badges';
import TeamTasks from './components/teamTasks';
import TeamViews from './components/teamViews';
import TeamNotRated from './components/teamNotRated';
import TeamMissingGoals from './components/teamMissingGoals';
import TeamLateReview from './components/teamLateReview';

export const Details = ({ profile, metric, show, close, range, offset }) => {
    const loading = useSelector(state => state.profile.loading);

    const closeModal = () => {
        close?.();
    };

    if (!metric) return null;

    if (loading)
        return (
            <Modal show={show} title={SystemText('User121/e4Metrics/Details/Title')} close={closeModal} footer={null}>
                <Loading />
            </Modal>
        );

    return (
        <Modal show={show} title={SystemText('User121/e4Metrics/Details/Title')} close={closeModal} footer={null}>
            {metric.property === 'BlogsPostsPublished' && <BlogPosts profileId={profile.id} range={range} offset={offset} />}
            {metric.property === 'KnowledgeBankQuestions' && (
                <KnowledgeBankQuestions range={range} offset={offset} profileId={profile.id} />
            )}
            {metric.property === 'KnowledgeBankAnswers' && (
                <KnowledgeBankAnswers range={range} offset={offset} profileId={profile.id} />
            )}
            {metric.property === 'AverageObjectiveScore' && (
                <Tasks profileId={profile.id} range={range} offset={offset} filter="rated" />
            )}
            {metric.property === 'ObjectivesCompleted' && (
                <Tasks profileId={profile.id} range={range} offset={offset} filter="completed" />
            )}
            {metric.property === 'BadgesWon' && <Badges inModal show profileId={profile.id} />}
            {metric.property === 'Logins' && <Logins range={range} offset={offset} inModal show profileId={profile.id} />}
            {metric.property === 'BlogComments' && (
                <BlogPosts type="comment" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'BlogLikes' && (
                <BlogPosts type="like" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'BlogViews' && (
                <BlogPosts type="view" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'QuestionLikes' && (
                <KnowledgeBankQuestions type="like" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'QuestionViews' && (
                <KnowledgeBankQuestions type="view" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'ObjectivesOnTime' && (
                <Tasks filter="ontime" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'ManagerCompleted' && (
                <TeamTasks filter="completed" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'ManagerAssigned' && (
                <TeamTasks filter="assigned" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'ManagerViews' && (
                <TeamViews type="view" range={range} offset={offset} inModal show profile={profile} />
            )}
            {metric.property === 'e4_staffcountnonrated' && <TeamNotRated type="view" inModal show profile={profile} />}
            {metric.property === 'e4_staffcountnonappraisal6' && (
                <TeamLateReview type="view" inModal show profile={profile} />
            )}
            {metric.property === 'e4_staffcountnongoals' && <TeamMissingGoals type="view" inModal show profile={profile} />}
            {metric.property === 'e4_stafftasksawaitingapproval' && (
                <TeamTasks filter="awaiting" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'e4_stafftasksoutstanding' && (
                <TeamTasks filter="outstanding" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
            {metric.property === 'e4_stafftasksoverdue' && (
                <TeamTasks filter="overdue" range={range} offset={offset} inModal show profileId={profile.id} />
            )}
        </Modal>
    );
};

export default withRouter(Details);
